import Radium from "radium";
import React from "react";

import { styles } from "@common/styles";
import { IUser } from "@common/models";

export interface IUserInfoProps {
  user: IUser;
}

class UserInfo extends React.Component<IUserInfoProps> {
  public render() {
    const listItemStyle = { ...styles.listItem, fontSize: "13px", flex: "1" };
    const wideItemStyle = { ...listItemStyle, width: "60%", flex: "3" };
    const rowStyle = { ...styles.row, alignItems: "left" };

    return (
      <div>
        <div style={rowStyle as any} className="row">
          <div style={listItemStyle as any}>Navn</div>
          <div style={wideItemStyle as any}>{this.props.user.name}</div>
        </div>
        <div style={rowStyle as any} className="row">
          <div style={listItemStyle as any}>Forhandler</div>
          <div style={wideItemStyle as any}>
            {this.props.user.departmentName}
          </div>
        </div>
        <div style={rowStyle as any} className="row">
          <div style={listItemStyle as any}>Brukernavn</div>
          <div style={wideItemStyle as any}>{this.props.user.username}</div>
        </div>
        <div style={rowStyle as any} className="row">
          <div style={listItemStyle as any}>Bruker-id</div>
          <div style={wideItemStyle as any}>{this.props.user.userId}</div>
        </div>
        <div style={rowStyle as any} className="row">
          <div style={listItemStyle as any}>Aktiv?</div>
          <div style={wideItemStyle as any}>
            {this.props.user.isActive ? "Ja" : "Nei"}
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(UserInfo);
